import { redirect } from '@tanstack/react-router';
import type { AuthUser } from './auth.ts';
import type { AppServices } from './services.ts';

/** Router context available to every route's beforeLoad/loader (set in src/main.tsx). */
export interface RouterContext {
  services: AppServices;
}

/**
 * Route guard: signed-out visitors go to /login and come back afterwards.
 * Only a convenience — the API enforces auth and roles on every call.
 */
export async function requireSignedIn(
  context: RouterContext,
  location: { href: string },
): Promise<{ user: AuthUser }> {
  const user = await context.services.auth.getUser();
  if (!user) {
    throw redirect({ to: '/login', search: { redirect: location.href } });
  }
  return { user };
}
